/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-redeclare */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { footerData } from './Footer_en';
import {
  // Desktop styled components
  Mainwrapper,
  StyledContentBlock,
  MobileSectionSeparator,
  StyledSection,
  FooterColumn,
  ColumnTitle,
  LinkList,
  LinkItem,
  MobileDownloadSection,
  StyledLink,
  FooterGrid,
  Storewrapper,
  Googleplay,
  GoogleplayImagewrapper,
  Appstore,
  AppstoreImagewrapper,
  Logocontentwrapper,
  Downwrapper,
  Copyright,
  Coprrighttext,
  Support,
  Supporttext,
  Supporttextorange,
  // Mobile styled components
  MobileWrapper,
  MobileSectionHeader,
  MobileSectionTitle,
  ToggleIcon,
  MobileSectionContent,
  MobileLinkList,
  MobileLinkItem,
  MobileLink,
  MobileAppButton,
  MobileAppImageWrapper,
  MobileFooterBottom,
  MobileLogoWrapper,
  MobileCopyright,
  MobileSupport,
  MobileSupportText,
  MobileSupportEmail,
  LogoImage,
} from './styled';

// Define TypeScript interfaces
interface LinkItem {
  message: string;
  href: string;
}

interface LinkGroup {
  message: string;
  id: string;
  links: LinkItem[];
}

interface SocialIcon {
  icon: string;
  href: string;
}

interface SocialIcons {
  telegram: SocialIcon;
  youtube: SocialIcon;
  instagram: SocialIcon;
  twitter: SocialIcon;
  facebook: SocialIcon;
  linkedin: SocialIcon;
  tiktok: SocialIcon;
  discord: SocialIcon;
}

interface ImageSource {
  src: string;
  alt: string;
  link?: string;
}

interface FooterData {
  footer: {
    links: LinkGroup[];
    legal: {
      copyright: string[];
    };
    logo: ImageSource;
    socialIcons: SocialIcons;
    appstore: ImageSource;
    playstore: ImageSource;
    copyright: string;
  };
}

const Footer: React.FC = () => {
  const [expandedSection, setExpandedSection] = useState<string | null>(null);
  const { footer } = footerData as unknown as FooterData;

  // Function to toggle mobile section expansion
  const toggleSection = (sectionName: string) => {
    if (expandedSection === sectionName) {
      setExpandedSection(null);
    } else {
      setExpandedSection(sectionName);
    }
  };

  const findLinksByTitle = (title: string): LinkItem[] => {
    const found = footer.links.find(item => item.message === title);
    return found ? found.links : [];
  };

  // Define mobile sections - updated to include all categories
  const mobileSections = [
    { id: 'company', title: 'Company' },
    { id: 'products', title: 'Products & Services' },
    { id: 'educate', title: 'Educate' },
    { id: 'get-crypto', title: 'Get Crypto' },
    { id: 'spend-crypto', title: 'Spend Crypto' },
    { id: 'crypto-games', title: 'Crypto Games' },
    { id: 'bitcoin-data', title: 'Bitcoin Data' },
    { id: 'exchanges', title: 'Exchanges' },
    { id: 'bitcoin-games', title: 'Bitcoin Games' },
    { id: 'follow', title: 'Follow' },
  ];

  return (
    <StyledSection>
      <StyledContentBlock>
        {/* Desktop Footer */}
        <Mainwrapper>
          <FooterGrid>
            <FooterColumn>
              <ColumnTitle>Download App</ColumnTitle>
              <Storewrapper>
                <Googleplay>
                  {/* eslint-disable-next-line react/jsx-no-target-blank */}
                  <a href={footer.playstore.link} target="_blank">
                    <GoogleplayImagewrapper>
                      <img
                        src={footer.playstore.src}
                        alt={footer.playstore.alt}
                      />
                    </GoogleplayImagewrapper>
                  </a>
                </Googleplay>
                <Appstore>
                  {/* eslint-disable-next-line react/jsx-no-target-blank */}
                  <a href={footer.appstore.link} target="_blank">
                    <AppstoreImagewrapper>
                      <img
                        src={footer.appstore.src}
                        alt={footer.appstore.alt}
                      />
                    </AppstoreImagewrapper>
                  </a>
                </Appstore>
              </Storewrapper>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Company</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Company').map((link, linkIndex) => (
                  <LinkItem key={`company-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Educate</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Educate').map((link, linkIndex) => (
                  <LinkItem key={`educate-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Products & Services</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Products & Services').map(
                  (link, linkIndex) => (
                    <LinkItem key={`products-${linkIndex}`}>
                      <StyledLink href={link.href} target="_blank">
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ),
                )}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Bitcoin Data</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Bitcoin Data').map((link, linkIndex) => (
                  <LinkItem key={`bitcoin-data-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Get Crypto</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Get Crypto').map((link, linkIndex) => (
                  <LinkItem key={`get-crypto-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Spend Crypto</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Spend Crypto').map((link, linkIndex) => (
                  <LinkItem key={`spend-crypto-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Crypto Games</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Crypto Games').map((link, linkIndex) => (
                  <LinkItem key={`crypto-games-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Exchanges</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Exchanges').map((link, linkIndex) => (
                  <LinkItem key={`exchanges-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Bitcoin Games</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Bitcoin Games').map((link, linkIndex) => (
                  <LinkItem key={`bitcoin-games-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Follow</ColumnTitle>
              <LinkList>
                {findLinksByTitle('Follow').map((link, linkIndex) => (
                  <LinkItem key={`follow-${linkIndex}`}>
                    <StyledLink href={link.href} target="_blank">
                      {link.message}
                    </StyledLink>
                  </LinkItem>
                ))}
              </LinkList>
            </FooterColumn>
          </FooterGrid>
          <Downwrapper>
            <Logocontentwrapper>
              <LogoImage src={footer.logo.src} alt={footer.logo.alt} />
            </Logocontentwrapper>
            <Copyright>
              <Coprrighttext>{footer.copyright}</Coprrighttext>
            </Copyright>
            <Support>
              <Supporttext>Support</Supporttext>
              <Supporttextorange>support@bitcoin.com</Supporttextorange>
            </Support>
          </Downwrapper>
        </Mainwrapper>

        {/* Mobile Footer */}
        <MobileWrapper>
          {/* Separate Download App section at the top */}
          <MobileDownloadSection>
            <MobileSectionTitle>Download App</MobileSectionTitle>
            <MobileAppButton href={footer.playstore.link} target="_blank">
              <MobileAppImageWrapper>
                <img src={footer.playstore.src} alt={footer.playstore.alt} />
              </MobileAppImageWrapper>
            </MobileAppButton>
            <MobileAppButton href={footer.appstore.link} target="_blank">
              <MobileAppImageWrapper>
                <img src={footer.appstore.src} alt={footer.appstore.alt} />
              </MobileAppImageWrapper>
            </MobileAppButton>
          </MobileDownloadSection>
          <MobileSectionSeparator />

          {mobileSections.map(section => (
            <React.Fragment key={section.id}>
              <MobileSectionHeader onClick={() => toggleSection(section.id)}>
                <MobileSectionTitle>{section.title}</MobileSectionTitle>
                <ToggleIcon>
                  {expandedSection === section.id ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="31"
                      height="31"
                      viewBox="0 0 31 31"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_6344_99941)">
                        <path
                          d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                          fill="#FF9500"
                        />
                        <path
                          d="M21 16.6049V15.0879H10V16.6049H21Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6344_99941">
                          <rect
                            width="31"
                            height="30"
                            fill="white"
                            transform="translate(0 0.347656)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="31"
                      height="31"
                      viewBox="0 0 31 31"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_6344_99941)">
                        <path
                          d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                          fill="#FF9500"
                        />
                        <path
                          d="M16.2592 10.3477H14.7422V21.3477H16.2592V10.3477Z"
                          fill="black"
                        />
                        <path
                          d="M21 16.6049V15.0879H10V16.6049H21Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6344_99941">
                          <rect
                            width="31"
                            height="30"
                            fill="white"
                            transform="translate(0 0.347656)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                </ToggleIcon>
              </MobileSectionHeader>

              <MobileSectionContent isExpanded={expandedSection === section.id}>
                <MobileLinkList>
                  {findLinksByTitle(section.title).map((link, linkIndex) => (
                    <MobileLinkItem key={`mobile-${section.id}-${linkIndex}`}>
                      <MobileLink href={link.href} target="_blank">
                        {link.message}
                      </MobileLink>
                    </MobileLinkItem>
                  ))}
                </MobileLinkList>
              </MobileSectionContent>
            </React.Fragment>
          ))}

          <MobileFooterBottom>
            <MobileLogoWrapper>
              <LogoImage src={footer.logo.src} alt={footer.logo.alt} />
            </MobileLogoWrapper>
            <MobileCopyright>{footer.copyright}</MobileCopyright>
            <MobileSupport>
              <MobileSupportText>Support</MobileSupportText>
              <MobileSupportEmail href="mailto:support@bitcoin.com">
                support@bitcoin.com
              </MobileSupportEmail>
            </MobileSupport>
          </MobileFooterBottom>
        </MobileWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Footer;
